<template>
    <div class="btnimg">

    </div>
</template>
<script>
export default {
    name: "loading",
    data() {
        return {

        };
    },
    created() {

    },
};
</script>
<style lang="less" scoped>
.btnimg {
    width: 11vw;
    height: 11vw;
    background: transparent url("../../assets//img//Desktop/1.png");
    background-size: 100%;
    position: fixed;
    top: 1.5vw;
    right: 1.5vw;
    opacity:0.7;
}
</style>